import React from 'react';
import ReactMarkdown from "react-markdown";
import { useMatchData } from "../../utils";
import { Chevron } from "../../../shared/svg";
import ToggleButton from "../../../shared/components/ToggleButton";
import { chevronDirection } from "../../../shared/svg/Svg";

const MatchPromo = () => {
  const { promoInfo } = useMatchData();

  const {
    matchPromo,
    promotionalMisc1,
    promotionalMisc2
  } = promoInfo;

  return (
    matchPromo
      ? (
        <div className="mls-o-match-strip__promo-wrapper">
          {
            matchPromo?.headline || matchPromo?.description
              ? (
                <div className="mls-o-match-strip__promo">
                  {
                    matchPromo?.headline
                      ? <div className="mls-o-match-strip__promo-headline">{matchPromo.headline}</div>
                      : null
                  }
                  {
                    matchPromo?.description
                      ? (
                        <div className="mls-o-match-strip__promo-description">
                          <ReactMarkdown source={matchPromo.description} />
                        </div>
                      )
                      : null
                  }
                </div>
              )
              : null
          }
          {
            matchPromo?.callToAction1 || matchPromo?.callToAction2 || promotionalMisc1?.displayText !== "" || promotionalMisc2.displayText !== ""
              ? (
                <div className="mls-o-match-strip__promo-cta-group">
                  {
                    matchPromo?.callToAction1?.displayText && matchPromo?.callToAction1?.url && matchPromo?.callToAction1?.url !== "" ?
                      (
                        <ToggleButton
                          target={`${matchPromo?.callToAction1?.openInNewTab ? "_blank" : "_self"}`}
                          rel={`${matchPromo?.callToAction1?.openInNewTab ? "noopener noreferrer" : ""}`}
                          alt={`${matchPromo?.callToAction1?.accessibleText ? matchPromo?.callToAction1?.accessibleText : ""}`}
                          href={`${matchPromo?.callToAction1?.url ? matchPromo?.callToAction1?.url : "#"}`}
                          className="mls-o-buttons__icon mls-o-buttons__icon--right">
                          {matchPromo?.callToAction1?.displayText}
                          <Chevron direction={chevronDirection.right} />
                        </ToggleButton>
                      ) : null
                  }
                  {
                    matchPromo?.callToAction2?.displayText && matchPromo?.callToAction2?.url && matchPromo?.callToAction2?.url !== "" ?
                      (
                        <ToggleButton
                          target={`${matchPromo?.callToAction2?.openInNewTab ? "_blank" : "_self"}`}
                          rel={`${matchPromo?.callToAction2?.openInNewTab ? "noopener noreferrer" : ""}`}
                          alt={`${matchPromo?.callToAction2?.accessibleText ? matchPromo?.callToAction2?.accessibleText : ""}`}
                          href={`${matchPromo?.callToAction2?.url ? matchPromo?.callToAction2?.url : "#"}`}
                          className="mls-o-buttons__icon mls-o-buttons__icon--right">
                          {matchPromo?.callToAction2?.displayText}
                          <Chevron direction={chevronDirection.right} />
                        </ToggleButton>
                      ) : null
                  }
                  {
                    promotionalMisc1?.displayText ?
                      (
                        <ToggleButton
                          target={`${promotionalMisc1?.openInNewTab ? "_blank" : "_self"}`}
                          rel={`${promotionalMisc1?.openInNewTab ? "noopener noreferrer" : ""}`}
                          alt={`${promotionalMisc1?.accessibleText ? promotionalMisc1?.accessibleText : ""}`}
                          href={`${promotionalMisc1?.url ? promotionalMisc1?.url : "#"}`}
                          className="mls-o-buttons__icon mls-o-buttons__icon--right">
                          {promotionalMisc1?.displayText}
                          <Chevron direction={chevronDirection.right} />
                        </ToggleButton>
                      ) : null
                  }
                  {
                    promotionalMisc2?.displayText ?
                      (
                        <ToggleButton
                          target={`${promotionalMisc2?.openInNewTab ? "_blank" : "_self"}`}
                          rel={`${promotionalMisc2?.openInNewTab ? "noopener noreferrer" : ""}`}
                          alt={`${promotionalMisc2?.accessibleText ? promotionalMisc2?.accessibleText : ""}`}
                          href={`${promotionalMisc2?.url ? promotionalMisc2?.url : "#"}`}
                          className="mls-o-buttons__icon mls-o-buttons__icon--right">
                          {promotionalMisc2?.displayText}
                          <Chevron direction={chevronDirection.right} />
                        </ToggleButton>
                      ) : null
                  }
                </div>
              )
              : null
          }
        </div>
      )
      : null
  );
};

export default MatchPromo;
